<template>
  <div class="logistics-box">

    <div class="logistics-panel">
      <van-row>
        <van-col class="cell2-1 cellbasic" span="12">商品信息</van-col>

      </van-row>

      <!--订单商品信息-->
      <goodscell class="goodsCell" :isShowBtn="(item.comment == 0 &&  detailInfo.orderInfo.handleOption.comment) ? true:false" :info="item" v-for="(item,index) in detailInfo.orderGoods" :key="index"></goodscell>

    </div>

    <div class="ship-info" v-if="ordershipInfo">
      <div class="ship-info-item">
        <div class="ship-name">物流状态</div>
        <div class="ship-text">{{ordershipInfo.uiReason}}</div>
      </div>
      <div class="ship-info-item">
        <div class="ship-com">承运公司:</div>
        <div class="ship-com-text">{{ordershipInfo.ShipperCode}}</div>
      </div>
      <div class="ship-info-item">
        <div class="ship-com">运单编号:</div>
        <div class="ship-com-text">{{ordershipInfo.LogisticCode}}</div>
      </div>
    </div>
    <van-steps direction="vertical" :active="0" v-if="ordershipInfo">
      <van-step v-for="(item,index) of ordershipInfo.Traces" :key="index">
        <h3>{{item.AcceptStation}}</h3>
        <p>{{item.AcceptTime}}</p>
      </van-step>
    </van-steps>

  </div>
</template>

<script>
import goodscell from "../../components/goodscell";
import { orderDetail, orderGetOrderShip } from "@/api/index";
// import { Toast, Dialog } from "vant";
import { Dialog } from "vant";

export default {
  name: "logistics",
  components: { goodscell },
  data() {
    return {
      ordershipInfo: null,
      detailInfo: {
        orderInfo: {
          consignee: "", //收货人
          address: "", //地址
          addTime: "", //下单时间
          orderSn: "", //订单编号
          actualPrice: 0, //实付价格
          mobile: "", //联系电话
          orderStatusText: "", //订单状态
          goodsPrice: 0, //商品合计
          id: 0, //订单id
          freightPrice: 0, //运费
          handleOption: {
            cancel: true, //取消订单
            delete: false, //删除订单
            pay: true, //去支付
            comment: false, //评论
            confirm: false, //确认收货
            refund: false, //退款
            rebuy: false //重新购买
          }
        },
        orderGoods: [
          {
            id: 0, //订单中的商品id
            orderId: 0, //订单id
            goodsId: 0, //商品id
            goodsName: "", //商品名称
            goodsSn: "", //商品编号
            productId: 0, //销售id
            number: 1, //数量
            price: 0, //商品价格
            specifications: [""], //规格
            picUrl: "", //图片
            comment: 0,
            addTime: "",
            updateTime: "",
            deleted: false
          }
        ]
      }
    };
  },

  mounted() {
    // document.getElementById("IDRootContainer").style.height =
    //   document.body.clientHeight - 60 + "px";
    orderDetail(this.$route.query.id).then(res => {
      if (res.data.errno == 0) {
        this.detailInfo = res.data.data;
        console.log(this.detailInfo.orderInfo.orderStatusText);
      } else {
        Dialog.alert({
          title: "提示",
          message: res.data.errmsg
        });
      }
    });
    orderGetOrderShip(this.$route.query.id).then(res => {
      console.log(res);
      if (res.data.errno == 0) {
        this.ordershipInfo = res.data.data;
        if (res.data.data.Reason) {
          this.ordershipInfo.uiReason = res.data.data.Reason;
        } else {
          switch (res.data.data.State) {
            case "0":
              this.ordershipInfo.uiReason = "暂无轨迹信息";
              break;
            case "1":
              this.ordershipInfo.uiReason = "已揽收";
              break;
            case "2":
              this.ordershipInfo.uiReason = "在途中";
              break;
            case "3":
              this.ordershipInfo.uiReason = "签收";
              break;
            case "4":
              this.ordershipInfo.uiReason = "问题件";
              break;
            default:
              this.ordershipInfo.uiReason = "暂无信息";
              break;
          }
        }
      }
    });
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.ship-info {
  padding: 1rem;
  box-sizing: border-box;
  background: #fff;
  margin: 0.5rem auto;
  .ship-info-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .ship-name {
      width: 7rem;

      margin: 0.5rem;
      text-align: left;
      font-family: PingFangSC-Semibold;
      font-size: 1.6rem;
      color: #424242;
      letter-spacing: 0;
    }
    .ship-text {
      font-size: 1.6rem;
      font-weight: 600;
      color: #a9936b;
    }
    .ship-com {
      width: 7rem;
      text-align: left;
      margin: 0.5rem;
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
    }
    .ship-com-text {
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
    }
  }
}
.logistics-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
  background-color: #f4f4f4;
  .logistics-panel {
    background-color: white;
    padding: 1.6rem 1.2rem;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 0.5rem 1.6rem 0 rgba(0, 0, 0, 0.05);
    margin: 0 auto;
    .cell2-1 {
      background-color: white;
      text-align: left;
      font-family: PingFangSC-Semibold;
      font-size: 1.6rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.6rem;
      margin-bottom: 1.6rem;
    }
    .cell2-2 {
      background-color: white;
      text-align: right;
    }
    .goodsCell {
      margin-bottom: 0.5rem;
      background-color: white;
    }
  }
  .van-step--vertical {
    // height: 4rem;

    display: flex;
    align-items: center;
    .van-step__title h3,
    .van-step__title p {
      font-size: 1.4rem;
      padding: 0;
      margin: 0;
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/person/logistics.vue